import React from 'react'
import { Tooltip } from 'react-tippy'
import 'react-tippy/dist/tippy.css'
import './FormInputTooltip.css'

const FormInputTooltip = ({ text, position }) => (
  <Tooltip
    arrow
    title={text}
    position={position || 'top'}
    trigger="mouseenter"
    animation="shift"
    size="small"
    style={{ marginLeft: 8, marginBottom: '0.45rem' }}
  >
    <i className="ri-information-fill tooltip-icon" />
  </Tooltip>
)

export default FormInputTooltip
